import React, { useEffect, useRef, useState} from 'react';
import emailjs from '@emailjs/browser';
import mail_icon from "../images/mail_icon.png";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useForm } from 'react-hook-form';


const ContactForm = () => {

    const [name, setName] = useState("");
    const [mail, setMail] = useState("");
    const [tel, setTel] = useState("");
    const [title, setTitle] = useState("");
    const [textarea, setTextarea] = useState("");
    const [checked, setChecked] = useState(false);
    const [contact, setContact] = useState(0);
    const [error, setError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [telError, setTelError] = useState(false);

    const { register, handleSubmit } = useForm();


    let form_element = document.getElementById("form-top");
    const FormError = document.getElementsByClassName("error");

    const CheckboxFlag = () =>{
        setChecked(!checked);
    };

    useEffect(() => {
        console.log("name = ", name);
        console.log("mail = ", mail);
        console.log("tel = ", tel);
        console.log("title = ", title);
        console.log("textarea = ", textarea);
        console.log("confirm = ", checked);
    }, );

    const form = useRef();

    

    const sendEmail = (e) => {
        e.preventDefault();

        const template_param = {
            to_email: "A",
            from_name: "A",
            title: "A",
            tel_number: "A",
            message: "A",
        };

        emailjs.sendForm('service_49tq3j7', 'template_3imxwcn', form.current, 'eks8wUNGKgIpdckou')
        // emailjs.sendForm('service_49tq3j7', 'template_3imxwcn', template_param, 'eks8wUNGKgIpdckou')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
    };

    // 正規表現
    const RegexEmail = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
    const RegexTel = /^[0-9.-]*$/;

    const ContactSwitch = (input) => {
        // 正規表現の確認：true/false
        console.log("正規表現 email:", RegexEmail.test(mail));
        console.log("正規表現 tel:", RegexTel.test(tel));

        if(checked && RegexEmail.test(mail) && RegexTel.test(tel) && name !== "" && mail !== "" && tel !== "" && title !== "" && textarea !== ""){
            setContact(input);
            setError(false);
            setEmailError(false);
            setTelError(false);
        }else{
            if(!checked || name === "" || mail === "" || tel === "" || title === "" || textarea === ""){
                setError(true);
                console.log("未入力エラー");
            }else{
                setError(false);
            }
            if(mail !== ""){
                if(!RegexEmail.test(mail)){
                    setEmailError(true);
                    console.log("Mailエラー");
                }else{
                    setEmailError(false);
                }
            }else{
                setEmailError(false);
            }

            if(tel !== "" && !RegexTel.test(tel)){
                setTelError(true);
                console.log("telエラー");
            }else{
                setTelError(false);
            }
        }
        // 入力のクリア
        if(input===3){
            setName("");
            setMail("");
            setTel("");
            setTitle("");
            setContact(0);
        }
        
        form_element = document.getElementById("form-top");
        // form_element.scrollIntoView({behavior: "smooth"});
        var headerOffset = 90;
        var elementPosition = form_element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: "auto"
      });
        console.log(form_element);
    };

    return (
        <div className='contact-form' id="form-top">
            <img src={mail_icon} alt="mailアイコン" />
            <h2>フォームでのお問い合わせ</h2>
            <div>
                <motion.div
                    className={contact === 0 ? "form-active" : "form-passive"}
                >
                    <form ref={form} className="h-adr">  
                        <h2>
                            下記フォームの必要事項を ご入力ください。<br/>
                            ※印については記載必須項目です。
                            <p className={error ? "" : "state-hidden"}>
                                <span className='error'>※未入力の項目があります</span>
                            </p>
                            <p className={emailError ? "" : "state-hidden"}>
                                <span className='error'>※メールアドレスの入力に誤りがあります</span>
                            </p>
                            <p className={telError ? "" : "state-hidden"}>
                                <span className='error'>※電話番号は半角英数字で入力してください</span>
                            </p>
                        </h2>
                        <dl style={{display:"none"}}>
                            <label htmlFor="to_mail">
                                <dt className="form__title required">送信先1</dt>
                            </label>
                            <dd className="form__input">
                                <input type="text"
                                name="to_mail_1"
                                value="info@kondo-some.co.jp"
                                />
                            </dd>
                        </dl>
                        <dl style={{display:"none"}}>
                            <label htmlFor="to_mail">
                                <dt className="form__title required">送信先2</dt>
                            </label>
                            <dd className="form__input">
                                <input type="text"
                                name="to_mail_2"
                                value=""
                                />
                            </dd>
                        </dl>
                        <dl className="form__row">
                            <label htmlFor="name">
                                <dt className="form__title required">お名前<span>※</span></dt>
                            </label>
                            <dd className="form__input">
                                <input type="text"
                                name="from_name"
                                value={name} 
                                onChange={(event) => setName(event.target.value)}
                                className="inquiry_box_right required" 
                                placeholder="染太郎"
                                maxlength="15"
                                />
                            </dd>
                        </dl>
                        <dl className="form__row">
                            <label htmlFor="name">
                                <dt className="form__title">メールアドレス<span>※</span></dt>
                            </label>
                            <dd className="form__input">                
                                <input type="email"
                                name="from_email"
                                value={mail} 
                                onChange={(event) => setMail(event.target.value)}
                                className="inquiry_box_right required"
                                placeholder="info@kondo-some.co.jp" 
                                />
                            </dd>
                        </dl>
                        <dl className="form__row">
                            <label htmlFor="name">
                                <dt className="form__title">電話番号<span>※</span></dt>
                            </label>
                            <dd className="form__input">
                                <input type="text"
                                name="tel-number" 
                                value={tel} 
                                onChange={(event) => setTel(event.target.value)}
                                className="inquiry_box_right required" 
                                placeholder="000-0000-0000"
                                minlength="2"
                                maxlength="15"
                                pattern="[\d\-]*"
                                />       
                            </dd>
                        </dl>
                        <dl className="form__row">
                            <label htmlFor="name">
                                <dt className="form__title">タイトル<span>※</span></dt>
                            </label>
                            <dd className="form__input">
                                <select 
                                name="title" 
                                value={title} 
                                onChange={(event) => setTitle(event.target.value)}
                                className="inquiry_box_right required" 
                                placeholder="以下よりご選択ください" 
                                >
                                    <option value="">以下よりご選択ください</option>
                                    <option value="商品について">商品について</option>
                                    <option value="会社について">会社について</option>
                                    <option value="その他">その他</option>
                                </select>
                            </dd>
                        </dl>
                        <dl className="form__row form__row--top">
                            <label htmlFor="name">
                                <dt className="form__title">お問い合わせ内容<span>※</span></dt>
                            </label>
                            <dd className="form__input">
                                <textarea name="message"
                                id='form-textarea'
                                className="textarea inquiry_box_right required"
                                onChange={() => setTextarea(document.getElementById('form-textarea').value)}
                                ></textarea>
                            </dd>
                        </dl>
                        <dl className="personal-information">
                            <h2>個人情報の取り扱いについて</h2>
                            <p className="contact__privacy">
                                株式会社近藤染工場（以下「当社」といいます）では、個人情報保護に関する取り組みとして、下記の方針に基づき個人情報の保護に努めます。<br/>
                                1. 当ホテルは、従業員及びホテル関係者に個人情報保護の重要性を認識させ、
                                個人情報を適切に保護するための個人情報保護コンプライアンス・プログラム
                                （当ホテルが保有する個人情報を保護するための方針、規定、規則、組織、計画、実施、監査.
                            </p>
                        </dl>
                        <label className="personal-information">
                            <input type="checkbox"
                            className="inquiry_box_right required"  
                            name="個人情報保護方針に同意する" 
                            value={checked}
                            onChange={CheckboxFlag}
                            />
                            <span className="fz15">上記に同意の上、チェックボックスにチェックを入れてください</span>
                            <span className="form__required red"></span>
                        </label>
                        <button type='button' className="submit-btn" onClick={() => ContactSwitch(1)}>
                            確認画面へ
                        </button>
                    </form>
                </motion.div>

                <motion.div
                    className={contact === 1 ? "form-active" : "form-passive"}
                >
                    <form onSubmit={sendEmail} className="h-adr">
                        <h2 style={{
                            margin:'0',
                            textAlign: 'center'
                        }}>
                            以下の内容でよろしければ、ページ下部の送信ボタンを押してください。<br/>
                            誤りがある場合は、入力画面に戻るのボタンを押して再度ご入力ください。
                        </h2>
                        <dl className="form__row">
                            <label htmlFor="name">
                                <dt className="form__title required">お名前</dt>
                            </label>
                            <span className='confirm-span'>{name}</span>
                        </dl>
                        <dl className="form__row">
                            <label htmlFor="name">
                                <dt className="form__title">メールアドレス</dt>
                            </label>
                            <span className='confirm-span'>{mail}</span>
                        </dl>
                        <dl className="form__row">
                            <label htmlFor="name">
                                <dt className="form__title">電話番号</dt>
                            </label>
                            <span className='confirm-span'>{tel}</span>
                        </dl>
                        <dl className="form__row">
                            <label htmlFor="name">
                                <dt className="form__title">タイトル</dt>
                            </label>
                            <span className='confirm-span'>{title}</span>
                        </dl>
                        <dl className="form__row form__row--top">
                            <label htmlFor="name">
                                <dt className="form__title">お問い合わせ内容</dt>
                            </label>
                            <span className='confirm-span'>{textarea}</span>
                        </dl>
                        <dl className="form__row">
                            <label htmlFor="name">
                                <dt className="form__title">個人情報の取り扱い</dt>
                            </label>
                            <span className='confirm-span'>同意する</span>
                        </dl>
                        <button type='button' className="submit-btn" onClick={() => ContactSwitch(0)}>
                            入力画面に戻る
                        </button>
                        <button type='submit' className="submit-btn" onClick={() => ContactSwitch(2)}>
                            送信する
                        </button>
                    </form>
                </motion.div>

                <motion.div
                    className={contact === 2 ? "form-active" : "form-passive"}
                >
                    <h2 style={{fontSize:"19px"}}>送信が完了しました</h2>
                    <button type='button' className="submit-btn" onClick={() => ContactSwitch(3)}>
                        入力画面に戻る
                    </button>
                </motion.div>  
            </div>
        </div>
    );

}
export default ContactForm;